import { registerPlugin } from '@capacitor/core';
const Sim = registerPlugin('Sim', {
    web: () => import('./web').then((m) => new m.SimWeb()),
});
export * from './definitions';
export { Sim };
//# sourceMappingURL=index.js.map